<div theme>
  <dxc-spinner [value]="value()" [label]="label()" [mode]="mode()" [margin]="margin()" [showValue]="showValue"></dxc-spinner>
</div>
